var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDashboard(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 35,
    viewBox: "0 0 35 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.0558 12.6821H7.9347C6.93938 12.6821 6.17376 11.8392 6.17376 10.9204V7.93525C6.17376 6.93994 7.01671 6.17432 7.9347 6.17432H15.0558C16.0511 6.17432 16.8167 7.0165 16.8167 7.93525V10.9204C16.8925 11.9165 16.0511 12.6821 15.0558 12.6821Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28.1477 29.8315H21.0273C20.032 29.8315 19.2664 28.9894 19.2664 28.0706V25.0847C19.2664 24.0894 20.1086 23.3237 21.0273 23.3237H28.1477C29.143 23.3237 29.9086 24.1667 29.9086 25.0847V28.0706C29.9852 29.0659 29.143 29.8315 28.1477 29.8315Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.0558 29.8318H7.9347C6.93938 29.8318 6.17376 29.011 6.17376 28.1156V16.8488C6.17376 15.878 7.01671 15.1318 7.9347 15.1318H15.0558C16.0511 15.1318 16.8167 15.9526 16.8167 16.8488V28.1156C16.8925 29.0856 16.0511 29.8318 15.0558 29.8318Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28.1477 20.8743H21.0273C20.032 20.8743 19.2664 20.0535 19.2664 19.158V7.89065C19.2664 6.92055 20.1086 6.17432 21.0273 6.17432H28.1477C29.143 6.17432 29.9086 6.99442 29.9086 7.89065V19.158C29.9852 20.1281 29.143 20.8743 28.1477 20.8743Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashboard);
export default __webpack_public_path__ + "static/media/Dashboard.ffe0f49615eb11ee8acfa4529392edd3.svg";
export { ForwardRef as ReactComponent };